/* @flow */

export const TrackingAttributes = {
  APPLICATION_ID: 'dlc',
  APPLICATION_COMPONENT_ID_SPA: 'spa',
  APPLICATION_COMPONENT_ID_DSW: 'dsw',
  APPLICATION_COMPONENT_ID_DDW: 'ddw',
  DLC_EVENT_NAME: 'dlcAnalyticsEventTriggered',
  PAGE_NAME_SEARCH_START: 'start_search',
  PAGE_NAME_SEARCH_RESULTS: 'dealer_search_results',
  PAGE_NAME_DEALER_DETAILS: 'dealer_details',
  LINK_NAME_DSW_DEALER_SELECT: 'dsw.dealerSelect',
  LINK_POSITION_DSW_DEALER_MAP: 'dsw.dealersMap',
  LINK_POSITION_DSW_DEALER_LIST: 'dsw.dealersList',
  LINK_POSITION_DDW_CONTACTS: 'ddw.contacts',
  LINK_POSITION_DDW_LINKS_LIST: 'ddw.linksList',
  LINK_POSITION_DDW_LINKS_HIGHLIGHTED: 'ddw.highlightedLinksList'
};

export const TrackingEventTypes = {
  PAGE_VIEW: 'pageview',
  CLICK: 'click'
};
